import React, { Component, useState } from "react";
import { useContext } from "react";
import CartContext from "./CartContext";
import { BsFillHeartFill } from "react-icons/bs";
import Slider from "react-slick";
import axios from "axios";
import { Showcase } from "./Showcase";
import { DemoLinks } from "./Home";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

import {
  Accordion,
  Table,
  Card,
  Carousel,
  Badge,
  Nav,
  Button,
  Row,
  Container,
  Col,
} from "react-bootstrap";
import { Link } from "react-router-dom";

export class CommonModules extends Component {
  static contextType = CartContext;

  render() {
    const modules = [
      InventoryModule,
      PurchasesModule,
      OrdersManagementModule,
      RawMaterialsModule,
      ProductionModule,
      ECommerceB2CModule,
      RetailPosModule,
      ProductServiceModule,
      SupplyChainModule,
      CrmModule,
      LeadsManagementModule,
      CouponsManagementModule,
      HrmModule,
      AccountingModule,
      ReportsModule,
    ];

    return (
      <Container className="my-5">
        <div className="text-center mb-4">
          <h4 className="fw-bold">Comprehensive ERP Modules</h4>
          <p className="text-muted">
            Manage your entire business operations with our robust and
            integrated ERP suite.
          </p>
        </div>

        <Row className="g-4">
          {modules.map((ModuleComponent, index) => (
            <Col key={index} xs={12} md={6} lg={6}>
              <div className="bg-light p-4 rounded shadow-sm h-100">
                <ModuleComponent />
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    );
  }
}

export class RetailPosModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Card className="p-2">
        <Card.Body>
          <Card.Title>Billing Point-Of-Sale (POS) / GST Billing</Card.Title>
          <Zoom>
            <Card.Img
              variant="top"
              src={
                this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                "retailposmodule.png"
              }
              style={{ objectFit: "contain" }}
            />
          </Zoom>
          <Card.Text>
            Experience seamless transactions with our Cloud-based and responsive
            Point-Of-Sale system. Designed to run on any device, it supports
            both Offline and Online modes. Easily integrate with universal
            barcode readers, POS printers, and scaling machines for a
            comprehensive solution.
          </Card.Text>
        </Card.Body>
      </Card>
    );
  }
}
export class RestaurantPosModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Card className="p-2">
        <Card.Body>
          <Card.Title>Point-Of-Sale (POS)</Card.Title>
          <Zoom>
            <Card.Img
              variant="top"
              src={
                this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                "restaurantposmodule.png"
              }
              style={{ objectFit: "contain" }}
            />
          </Zoom>
          <Card.Text>
            Experience seamless transactions with our Cloud-based and responsive
            Point-Of-Sale system. Designed to run on any device, it supports
            both Offline and Online modes. Easily integrate with universal
            barcode readers, POS printers, and scaling machines for a
            comprehensive solution.
          </Card.Text>
        </Card.Body>
      </Card>
    );
  }
}
export class CaptainappModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Captain APP</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "captainappmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Captain App presented with a detailed Dashboard that shows Status
              of all the Tables in the Restaurant including Occupied/Vacant,
              Total Ordered Items, Total Sale. Tables are mapped with Waiters to
              manage the table and to receive orders from customers. Table
              Orders are smoothly handled with workflow between Table and
              Kitchen.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class ECommerceB2CModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>ECOMMERCE B2C / Online Store</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "ecommerceb2cmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              We offers premium ECommerce solution which provide stunning themes
              and custom themes. Our ECOMMERCE solution is a 100% marketing and
              selling platform. It provides many placeholders to display ADs. It
              comes with Fuzzy-Search capabilities. We integrate with Secured
              Payment gateways along with COD payment options. Our solution is
              user-friendly and super fast.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class ECommerceModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>ECOMMERCE B2C/B2B</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "ecommerceb2cmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              We offers premium ECommerce solution which provide stunning themes
              and custom themes. Our ECOMMERCE solution is a 100% marketing and
              selling platform. It provides many placeholders to display ADs. It
              comes with Fuzzy-Search capabilities. We integrate with Secured
              Payment gateways along with COD payment options. Our solution is
              user-friendly and super fast.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class KioskModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Kiosk - Self Ordering </Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "kioskmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              We offer KIOSK based custom solution for any Retail business. The
              Kiosk can be used as Digital catalog/Menu and Self-ordering POS.
              We provide Software solution and setup to onboard KIOSK based
              solution.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class QrcodeModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Self Ordering solution via QRCODE </Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "qrcodemodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              We offer custom QRCODE based self ordering solution for any
              Retail. Customers can scan your Business QRCODE to see the Menu of
              your Products on their own Phone/Tablet for self Ordering.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class ECommerceB2BModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>ECOMMERCE B2B</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "ecommerceb2bmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              We offers premium ECommerce solution which provide stunning themes
              and custom themes. Our ECOMMERCE solution is a 100% marketing and
              selling platform. It provides many placeholders to display ADs. It
              comes with Fuzzy-Search capabilities. We integrate with Secured
              Payment gateways along with COD payment options. Our solution is
              user-friendly and super fast.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class ECommerceB2cRestaurantModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="d-flex justify-content-center">
        <Card className="p-2">
          <Card.Body>
            <Card.Title>ECOMMERCE</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "ecommerceb2crestaurantmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              We offers premium ECommerce solution which provide stunning themes
              and custom themes. Our ECOMMERCE solution is a 100% marketing and
              selling platform. It provides many placeholders to display ADs. It
              comes with Fuzzy-Search capabilities. We integrate with Secured
              Payment gateways along with COD payment options. Our solution is
              user-friendly and super fast.
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export class InventoryModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Card className="p-2">
        <Card.Body>
          <Card.Title>
            Warehouse, Product(Finished Good) Inventory & Stock Management
          </Card.Title>
          <Zoom>
            <Card.Img
              variant="top"
              src={
                this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                "inventorymodule.png"
              }
              style={{ objectFit: "contain" }}
            />
          </Zoom>
          <Card.Text>
            Easily manage your Inventory and stock anytime and anywhere with any
            PC/Phone/Tablet. Our Inventory system supports Single and Multi
            variant Products. Bulk upload/download of Inventory supported for
            easy migration from existing system.
          </Card.Text>
        </Card.Body>
      </Card>
    );
  }
}
export class PurchasesModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Card className="p-2">
        <Card.Body>
          <Card.Title>Purchase Management</Card.Title>
          <Zoom>
            <Card.Img
              variant="top"
              src={
                this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                "purchasemodule.png"
              }
              style={{ objectFit: "contain" }}
            />
          </Zoom>
          <Card.Text>
            Efficiently manage your suppliers, Purchase Requests (PR), and
            Purchase Orders (PO). This module ensures seamless inventory
            restocking and supplier coordination, enabling smooth procurement
            processes.
          </Card.Text>
        </Card.Body>
      </Card>
    );
  }
}

export class OrdersManagementModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Card className="p-2">
        <Card.Body>
          <Card.Title>Orders Management</Card.Title>
          <Zoom>
            <Card.Img
              variant="top"
              src={
                this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                "ordersmodule.png"
              }
              style={{ objectFit: "contain" }}
            />
          </Zoom>
          <Card.Text>
            Manage your orders efficiently with our Orders Management module.
            Track the entire workflow from order placement to delivery, ensuring
            timely processing, packaging, and payment collection.
          </Card.Text>
        </Card.Body>
      </Card>
    );
  }
}

export class PackagingManagementModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Card className="p-2">
        <Card.Body>
          <Card.Title>Packaging Management</Card.Title>
          <Zoom>
            <Card.Img
              variant="top"
              src={
                this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                "packagemodule.png"
              }
              style={{ objectFit: "contain" }}
            />
          </Zoom>
          <Card.Text>
            Manage your orders efficiently with our Orders Management module.
            Track the entire workflow from order placement to delivery, ensuring
            timely processing, packaging, and payment collection.
          </Card.Text>
        </Card.Body>
      </Card>
    );
  }
}

export class DeliveryManagementModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Delivery Management</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "deliverymodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Online or Table Orders are pushed into powerful Digital Queue to
              address priority basis. The entire Order management workflow
              ensure, Received, Packaged, Delivered and Payment received.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export class KdsModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Kitchen Display System(KDS) & Chef App</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "packagemodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              KDS is our Orders and Queue Insight Display Screen where orders
              are prepared and delivered on a priority basis. In KDS, Table
              Orders, Takeaway, and Home Delivery orders are managed
              efficiently. The Chef App view provides a summary of items that
              need to be prepared and delivered. It also offers insights into
              items that have already been prepared and delivered.
              <br></br>
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export class RecipeManagementModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Recipe Management & Product Cost Estimation</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "receipemodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Manage your recipes and ingredients with our Recipe Management
              module. Create and modify recipes, track ingredient usage, and
              ensure consistency in your dishes. This module streamlines the
              process of recipe creation and estimation, making it easier to
              maintain quality and efficiency in your kitchen.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class SuppliersModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Suppliers Management</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "suppliermodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Engage suppliers into the system to manage their inventory and to
              prioritize purchase orders from Client. Plan Dispatching the
              orders via Logistic Partners. And to track Delivered orders and
              Payments received from the Client.
            </Card.Text>
            {/* <Button variant="primary">Learn more...</Button> */}
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class RawMaterialsModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>
              Warehouse, Raw Materials Inventory Management
            </Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "rawmaterialsmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Easily upload Products items from an excel file to Inventory
              Database. Powerful app to manage the Price, Discounts,
              Availability, Category, Groups, Product Images/Videos, etc.,
              Inventory can be managed with PC/Tablet/Phone.
            </Card.Text>
            {/* <Button variant="primary">Learn more...</Button> */}
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class ProductionModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Production Management in Manufacturing</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "productionmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Manage Production workflow with ease. With this module utilize Raw
              materials and manage production workflow and procedures to produce
              Product.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export class SupplyChainModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Supply Chain Management</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "supplychainmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Manage end-to-end supply chain process that includes Product
              Inventory, Procurement, Manufacturing, Sales, Service and Support.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export class CrmModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Customers Database </Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "crmmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Leverage our powerful CRM module to gain valuable insights into
              customer behavior, sales trends, and engagement metrics. This
              comprehensive platform enables efficient customer data management,
              follow-ups, and query resolution, ensuring enhanced customer
              satisfaction and loyalty.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export class HrmModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Human Resource Management - HRM</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "hrmmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              We got all usecases covered to manage your employees from
              onboarding to exit. From recruitment, attendance tracking,
              performance evaluation, to payroll and exit formalities, our HRM
              module ensures a seamless and efficient employee management
              experience.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export class AccountingModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Card className="p-2">
        <Card.Body>
          <Card.Title>Accounting & Payroll Management</Card.Title>
          <Zoom>
            <Card.Img
              variant="top"
              src={
                this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                "financemodule.png"
              }
              style={{ objectFit: "contain" }}
            />
          </Zoom>
          <Card.Text>
            Simplify your day-to-day accounting and payroll processes with our
            comprehensive module. Manage Receivables (AR), Payables (AP),
            Revenues, Expenses, Asset Management, and Ledger entries
            effortlessly. Generate advanced reports and analytics to support
            informed decision-making and ensure financial transparency.
          </Card.Text>
        </Card.Body>
      </Card>
    );
  }
}
export class ProjectsModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Card className="p-2">
        <Card.Body>
          <Card.Title>Projects Management</Card.Title>
          <Zoom>
            <Card.Img
              variant="top"
              src={
                this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                "projectmodule.png"
              }
              style={{ objectFit: "contain" }}
            />
          </Zoom>
          <Card.Text>
            Manage all Projects with Ease. Associate Employees and make a Team
            to execute Project with ease. One platform to manage all Project
            Tasks, Backlogs and Risks and Cost.
          </Card.Text>
        </Card.Body>
      </Card>
    );
  }
}
export class ReportsModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Dashboards, Analytics & Reports</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "reportsmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Get a comprehensive 360-degree view of your business with powerful
              analytics and advanced reporting tools. Gain insights into sales,
              customer behavior, inventory, and financial performance to make
              informed decisions and drive growth.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export class MarketingModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Marketing</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "marketingmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Do marketing with our powerfull platform and solutions!
              SMS/Email/WhatsApp campaign and Social Media Campaigns. Generate
              Digital Catalog to showcase your Products.
              <br></br>
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class LeadsManagementModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Leads Management</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "leadsmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Manage your leads and prospects with our Leads Management module.
              Capture, track, and nurture leads through the sales funnel. This
              is a great channel to understand customer needs and preferences,
              enabling you to tailor your offerings and improve conversion
              rates.
              <br></br>
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class QuoteManagementModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Quotation Management</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "quotemodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Manage customer quotations and proposals with our Quote Management
              module. Create, send, and track quotes to streamline the sales.
              <br></br>
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class SalesOrderModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Sales Order Management</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "salesordermodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Manage all Sales Orders with East that are received from
              Distributors/Resellers or Consumers. Track Stocks, Orders
              Delivered and Payment received.
              <br></br>
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export class CouponsManagementModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Coupons Management</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "couponmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Manage your coupons and discounts with our Coupons Management
              module. Create and distribute coupons to customers, track their
              engagement, and analyze the effectiveness of your promotional
              campaigns. This module helps you attract new customers and retain
              existing ones. This module provide Promotional, Rewards, Referral
              and Refund coupons.
              <br></br>
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class DigitalCatalogModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Digital Menu/Catalog</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "digitalcatalogmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Digital Catalog is a powerful tool to manage your Restaurant Menu.
              It provides a stunning and user-friendly interface for customers
              to view products and Prices. digital menu can be printed and
              displayed on TV/LED screen. It is integrated with the Captain App.
              <br></br>
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class GreetAppModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Customer Greeting App</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "greetingappmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Manage customer waiting list with our Greet App. Customers can
              check-in and get a token number. The Greet App provides a summary
              of all the available Tables and customer priority list. It also
              provides a summary of all the available Tables and customer
              priority list. The Greet App is integrated with the Captain App to
              ensure smooth workflow between Table and Kitchen.
              <br></br>
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}
export class DemoButton extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <div className="text-center">
          <Button variant="primary" className="getstated-round my-3">
            <a
              href="https://wa.me/9880582728"
              class=" nav-link  bg-primary text-white px-2 text-center p-0 m-0 rounded"
            >
              <Row>
                <Col xs={2}>
                  <i class="bi bi-phone-vibrate vibrate-phone fs-1 text-warning me-3"></i>
                </Col>
                <Col xs={10} className="text-center fs-6">
                  <span className="text-dark">
                    Book a Demo <br />
                  </span>
                  +91- 98805 82728
                </Col>
              </Row>
            </a>
          </Button>
        </div>
      </>
    );
  }
}
export class ContactSalesButton extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Button
          variant="outline-secondary"
          size="sm"
          className="ms-2 text-start"
        >
          <a href="https://wa.me/9880582728" class=" ">
            <span>
              Contact Sales
              <i
                class="bi bi-phone-vibrate  text-warning my-5 px-3"
                style={{ fontSize: "32px" }}
              ></i>
            </span>
          </a>
        </Button>
      </>
    );
  }
}

export class DemoButtonNav extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <div className="text-center">
          <Button className="getstated-round my-0 bg-white text-primary border-secondary">
            <a
              href="https://wa.me/9880582728"
              // class="bg-primary text-white px-0 text-center p-0 m-0 rounded"
              class="bg-white text-primary px-0 text-center p-0 m-0 rounded"
            >
              <Row>
                <Col xs={2}>
                  <i
                    class="bi bi-phone-vibrate vibrate-phone text-warning me-0 m-0 p-0"
                    style={{ fontSize: "32px" }}
                  ></i>
                </Col>
                <Col xs={10} className="text-center verticalaligncentertd">
                  <span
                    className="text-dark text-muted"
                    style={{ fontSize: "12px" }}
                  >
                    Book a Demo
                    <br />
                    <b className="text-primary" style={{ fontSize: "14px" }}>
                      +91- 98805 82728
                    </b>
                  </span>
                </Col>
              </Row>
            </a>
          </Button>
        </div>
      </>
    );
  }
}

export class ProductServiceModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Product Servicing</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "servicemodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Our Product Servicing modules provide very effective and
              productive ways to manage Service operation with ease. It offers
              key modules to manage Customers, Service Request, Tasks Inventory
              Management, Booking, Workflow automation, Invoice and Delivery
              process modules.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export class ServiceBookingModule extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Card className="p-2">
          <Card.Body>
            <Card.Title>Post-Sale Servicing</Card.Title>
            <Zoom>
              <Card.Img
                variant="top"
                src={
                  this.context.GetEcSettingValueByName("StorageBlobImageUrl") +
                  "servicebookingmodule.png"
                }
                style={{ objectFit: "contain" }}
              />
            </Zoom>
            <Card.Text>
              Our Service Booking Solution simplifies appointment management for
              service-based businesses. It enables customers to schedule
              services online via web or mobile, supports real-time
              availability, automated reminders, secure payments (RazorPay,
              PhonePe, COD), and staff assignment. Built-in dashboards and CRM
              tools help streamline operations, reduce no-shows, and improve
              customer satisfaction.
            </Card.Text>
          </Card.Body>
        </Card>
      </>
    );
  }
}
